import { __read, __values } from "tslib";
import { GraphQLInputObjectType, GraphQLInterfaceType, GraphQLObjectType, } from 'graphql';
import { MapperKind } from './Interfaces';
import { mapSchema } from './mapSchema';
export function filterSchema(_a) {
    var _b;
    var schema = _a.schema, _c = _a.typeFilter, typeFilter = _c === void 0 ? function () { return true; } : _c, _d = _a.fieldFilter, fieldFilter = _d === void 0 ? undefined : _d, _e = _a.rootFieldFilter, rootFieldFilter = _e === void 0 ? undefined : _e, _f = _a.objectFieldFilter, objectFieldFilter = _f === void 0 ? undefined : _f, _g = _a.interfaceFieldFilter, interfaceFieldFilter = _g === void 0 ? undefined : _g, _h = _a.inputObjectFieldFilter, inputObjectFieldFilter = _h === void 0 ? undefined : _h, _j = _a.argumentFilter, argumentFilter = _j === void 0 ? undefined : _j;
    var filteredSchema = mapSchema(schema, (_b = {},
        _b[MapperKind.QUERY] = function (type) { return filterRootFields(type, 'Query', rootFieldFilter, argumentFilter); },
        _b[MapperKind.MUTATION] = function (type) {
            return filterRootFields(type, 'Mutation', rootFieldFilter, argumentFilter);
        },
        _b[MapperKind.SUBSCRIPTION] = function (type) {
            return filterRootFields(type, 'Subscription', rootFieldFilter, argumentFilter);
        },
        _b[MapperKind.OBJECT_TYPE] = function (type) {
            return typeFilter(type.name, type)
                ? filterElementFields(GraphQLObjectType, type, objectFieldFilter || fieldFilter, argumentFilter)
                : null;
        },
        _b[MapperKind.INTERFACE_TYPE] = function (type) {
            return typeFilter(type.name, type)
                ? filterElementFields(GraphQLInterfaceType, type, interfaceFieldFilter || fieldFilter, argumentFilter)
                : null;
        },
        _b[MapperKind.INPUT_OBJECT_TYPE] = function (type) {
            return typeFilter(type.name, type)
                ? filterElementFields(GraphQLInputObjectType, type, inputObjectFieldFilter || fieldFilter)
                : null;
        },
        _b[MapperKind.UNION_TYPE] = function (type) { return (typeFilter(type.name, type) ? undefined : null); },
        _b[MapperKind.ENUM_TYPE] = function (type) { return (typeFilter(type.name, type) ? undefined : null); },
        _b[MapperKind.SCALAR_TYPE] = function (type) { return (typeFilter(type.name, type) ? undefined : null); },
        _b));
    return filteredSchema;
}
function filterRootFields(type, operation, rootFieldFilter, argumentFilter) {
    if (rootFieldFilter || argumentFilter) {
        var config_1 = type.toConfig();
        Object.entries(config_1.fields).forEach(function (_a) {
            var e_1, _b;
            var _c = __read(_a, 2), fieldName = _c[0], field = _c[1];
            if (rootFieldFilter && !rootFieldFilter(operation, fieldName, config_1.fields[fieldName])) {
                delete config_1.fields[fieldName];
            }
            else if (argumentFilter) {
                try {
                    for (var _d = __values(Object.keys(field.args)), _e = _d.next(); !_e.done; _e = _d.next()) {
                        var argName = _e.value;
                        if (!argumentFilter(operation, fieldName, argName, field.args[argName])) {
                            delete field.args[argName];
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        });
        return new GraphQLObjectType(config_1);
    }
    return type;
}
function filterElementFields(ElementConstructor, type, fieldFilter, argumentFilter) {
    if (fieldFilter || argumentFilter) {
        var config_2 = type.toConfig();
        Object.entries(config_2.fields).forEach(function (_a) {
            var e_2, _b;
            var _c = __read(_a, 2), fieldName = _c[0], field = _c[1];
            if (fieldFilter && !fieldFilter(type.name, fieldName, config_2.fields[fieldName])) {
                delete config_2.fields[fieldName];
            }
            else if (argumentFilter && 'args' in field) {
                try {
                    for (var _d = __values(Object.keys(field.args)), _e = _d.next(); !_e.done; _e = _d.next()) {
                        var argName = _e.value;
                        if (!argumentFilter(type.name, fieldName, argName, field.args[argName])) {
                            delete field.args[argName];
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        });
        return new ElementConstructor(config_2);
    }
}
//# sourceMappingURL=filterSchema.js.map